import { AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { CornerstoneLiteDirective } from '../cornerstone-lite.directive';
import { GlobalVariables } from 'src/app/data/global-variables';


@Component({
  selector: 'app-series-scrollbar',
  templateUrl: './series-scrollbar.component.html',
  styleUrls: ['./series-scrollbar.component.css']
})
export class SeriesScrollbarComponent implements AfterViewInit {

  @Input() directive!: CornerstoneLiteDirective;

  @ViewChild('Scrollbar') scrollbarElement!: ElementRef;

  get isPageSmall() {
    return this.globalVariables.isPageSmall;
  }

  // private currentViewport: DicomViewer;
  // currentSerie: Serie;

  public height: string = '100%';
  public top: number = 0;

  public showImageNumber = false;

  get imageNumber() {
    return this.directive.currentIndex;
  }

  @HostListener('window:mouseup', ['$event'])
  @HostListener('window:touchend', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.showImageNumber = false;
  }

  @HostListener('window:mousemove', ['$event'])
  @HostListener('window:touchmove', ['$event'])
  onMouseMove(evt: MouseEvent | TouchEvent) {
    if (this.showImageNumber) {
      if (evt instanceof MouseEvent) {
        console.log('por aquí', evt.offsetY);
        console.log('evt', evt);
        const maxHeight = this.scrollbarElement.nativeElement.clientHeight;
        if (evt.movementY < 0 && this.top <= 0) {
          this.top = 0;
        } else if (evt.movementY > 0 && this.top >= (maxHeight - this.calculateHeight())) {
          this.top = maxHeight - Math.floor(this.calculateHeight());
        } else {
          this.top += evt.movementY;
        }
        console.log('this.top', this.top);
        // Que cuente en la mitad de la barra
        this.calculateIndexByPosition(((this.top + this.calculateHeight() / 2)));
      }
      if (evt instanceof TouchEvent) {
        this.calculateIndexByPosition(evt.touches[0].clientY);
        this.top = evt.touches[0].clientY - Math.floor(this.calculateHeight() / 2);
      }

    }
  }

  constructor(
    // private viewportsService: ViewportsService
    private globalVariables: GlobalVariables
  ) {
    document.addEventListener('dicomViewer:scrolledImage', () => {
      console.log('ENTRA1');
      if (this.directive != null)
        this.setScrollbarByIndex(this.directive.currentIndex);
    })
    document.addEventListener('dicomViewer:changedSerie', () => {
      console.log('ENTRA2');
      if (this.directive != null)
        this.refreshData();
    })
    window.addEventListener('resize', () => {
      if (this.directive != null) {
        if (this.height != this.calculateHeight() + 'px') {
          console.log('ENTRA3');
          this.refreshData();
        }
      }
    })
  }

  ngAfterViewInit(): void {
    this.refreshData();
  }

  private refreshData() {
    this.height = this.calculateHeight() + 'px';
    this.setScrollbarByIndex(this.directive.currentIndex);
  }

  public onMouseDownScrollbar(evt: MouseEvent | TouchEvent) {
    if ((evt.target as any).id == 'scrollbar') {
      if (evt instanceof TouchEvent) {
        this.calculateIndexByPosition(evt.touches[0].clientY);
        this.showImageNumber = true;
        this.top = evt.touches[0].clientY - Math.floor(this.calculateHeight() / 2);
      } else if (evt instanceof MouseEvent && evt.button == 0 && evt.buttons == 1) {
        this.calculateIndexByPosition(evt.offsetY);
        this.showImageNumber = true;
        // this.top = evt.offsetY - Math.floor(this.calculateHeight() / 2);
      }
    }
  }

  private calculateHeight(): number {
    const maxHeight = this.scrollbarElement.nativeElement.clientHeight;
    return (maxHeight / this.directive.imageList.length);
  }

  private calculateIndexByPosition(pos: number) {
    const maxHeight = document.getElementById('scrollbar')!.clientHeight;
    let res = pos / (maxHeight / this.directive.imageList.length);
    res = Math.floor(res);

    this.directive.jumpToIndex(res);
    return res;
  }

  private setScrollbarByIndex(index: number) {
    const maxHeight = this.scrollbarElement.nativeElement.clientHeight;
    const pos = (maxHeight / this.directive.imageList.length) * index
    this.top = pos
  }

}
